import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	DestroyRef,
	inject,
	OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { UserPreferences } from '@reach/interfaces/user/preferences.interface';

import { SettingsService } from '~app-client/core/services';
import { ReachTranslateService } from '~app-client-item/core/services/translate.service';

@Component({
	selector: 'settings-reactor',
	template: '',
	styles: [':host { display: none; } '],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class SettingsReactorComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly translateService = inject(ReachTranslateService);
	private readonly settingsService = inject(SettingsService);
	private readonly cdRef = inject(ChangeDetectorRef);

	constructor() {
		this.cdRef.detach();
	}

	ngOnInit(): void {
		this.settingsService.settings$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((settings) => {
				this.handleSettings(settings);
			});
	}

	private handleSettings(settings: UserPreferences): void {
		this.translateService.setLanguage(settings.general.language);
	}
}
